import { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Divider, Typography } from 'antd';
import Icon from '@ant-design/icons';
import { ReactComponent as CancelSvg } from '../../../../assets/icons/cancel.svg';
import { ReactComponent as CancelBlackSvg } from '../../../../assets/icons/cancel-black.svg';
import { useTheme } from '../../../../context/ThemeContext';
import TripTracking from '../../../VehicleMonitoring/components/TripTracking';

const { Text } = Typography;

const TripTrackingModal = ({ isModalOpen, setIsModalOpen, selectedTrip }) => {
  const { theme } = useTheme();
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      centered
      open={isModalOpen}
      destroyOnHidden
      title={
        <div>
          <div
            className="broadcast-modal-title"
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <Text>{`Trip ID: ${selectedTrip?.trip_id}`}</Text>

            <Icon
              component={theme === 'dark' ? CancelSvg : CancelBlackSvg}
              onClick={handleCancel}
            />
          </div>
          <Divider />
        </div>
      }
      footer={[]}
      className="trip-tracking-modal"
      closable={false}
      width="80%"
    >
      <TripTracking
        isFullScreen={isFullScreen}
        onFullScreenToggle={() => setIsFullScreen(prev => !prev)}
        selectedTrip={{
          ...selectedTrip,
          registration: selectedTrip?.vehicle_number,
        }}
        selectedAnomlayId={selectedTrip?.anomaly_id}
      />
    </Modal>
  );
};

TripTrackingModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  selectedTrip: PropTypes.shape({
    trip_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    anomaly_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    vehicle_number: PropTypes.string,
  }),
};

export default TripTrackingModal;
